import React, { useState, useEffect } from 'react'
import Pill from 'srcReact/components/common2/Pill'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getParsedMessage, scrollToElement } from 'srcReact/helpers/feedHelper'
import { isValidDate } from 'srcReact/helpers/datetimeHelper'

function PinnedFeeds({
  feedPinnedData,
  feedIdToScroll,
  totalFeedPinned,
  entity,
  isFocusSetRef,
  feedContainerCSS,
  pageLastVisitedAt,
  renderFeedContent
}) {
  const { t } = useTranslation()
  const {
    common: { isNative, isMobile, isTablet, pageMeta }
  } = useSelector((state) => state)
  const [showFeedAccordion, setShowFeedAccordion] = useState(false)
  const [showPinnedCount, setShowPinnedCount] = useState(1)
  const [lastVisitedAt, setLastVisitedAt] = useState(null)

  useEffect(() => {
    if (isMobile || isNative) {
      setShowPinnedCount(1)
    } else if (isTablet) {
      setShowPinnedCount(2)
    } else {
      setShowPinnedCount(3)
    }
  }, [isNative, isMobile, isTablet])

  useEffect(() => {
    if (feedIdToScroll > 0) {
      scrollToPinnedFeed(feedIdToScroll)
    }
  }, [feedIdToScroll])

  useEffect(() => {
    const lastVisitedDate = new Date(pageMeta?.last_visit_date_utc)
    if (isValidDate(lastVisitedDate)) {
      setLastVisitedAt(lastVisitedDate)
    }
  }, [pageLastVisitedAt])

  const scrollToPinnedFeed = (feedId) => {
    setShowFeedAccordion(true)
    setTimeout(() => {
      const elementToScroll = document.querySelector(`div[data-id="${feedId}"]`)
      scrollToElement(elementToScroll, 1, 1000)
      isFocusSetRef.current = true
    }, 100)
  }

  return (
    <React.Fragment>
      <div className={styles.pinnedDataWrapper}>
        <div className={styles.pinnedPills}>
          {feedPinnedData.map((feed, index) => {
            let showNewBadge = false
            let lastPinnedDate = new Date(feed.pinned_to_the_top_at)
            if (isValidDate(lastPinnedDate) && lastVisitedAt) {
              if (lastPinnedDate.getTime() > lastVisitedAt.getTime()) {
                showNewBadge = true
              }
            }

            let text = getParsedMessage(feed.message)
            text = text?.body?.textContent
            if (!text && feed.files.length > 0) {
              const fileName = feed.files[0].name
              if (fileName.length > 15) {
                const name = fileName.replace(/\.[^/.]+$/, '')
                const extension = fileName?.split('.').pop()
                //first 8 charater + ... + last 7 character
                text = `${name.slice(0, 4)}...${name.slice(-4)}.${extension}`
              } else {
                text = fileName
              }
            } else {
              // first 15 characters + "..."
              if (text.length > 15) {
                text = `${text.slice(0, 15)}...`
              }
            }
            if (index < showPinnedCount) {
              return (
                <div className={styles.pillContainer}>
                  {showNewBadge && <div className={styles.isNew}>{t('global.new')}</div>}
                  <Pill
                    onClick={() => scrollToPinnedFeed(feed.id)}
                    className={styles.pinnedData}
                    text={text}
                    type='pinned'
                    dataId={feed.id}
                  />
                </div>
              )
            }
          })}
          {totalFeedPinned > showPinnedCount ? (
            <div className={styles.remainingPins}>{`+${feedPinnedData.length - showPinnedCount}`}</div>
          ) : null}
        </div>
        <button className={styles.accordion} onClick={() => setShowFeedAccordion(!showFeedAccordion)}>
          <div className={styles.heading}>
            {showFeedAccordion
              ? t('mixrHome.feeds.hidePinnedPosts') + ' ' + `(${totalFeedPinned})`
              : t('mixrHome.feeds.showPinnedPosts') + ' ' + `(${totalFeedPinned})`}
          </div>
          <Icon name={showFeedAccordion ? 'chevron-up' : 'chevron-down'} size='medium' />
        </button>
      </div>
      {showFeedAccordion &&
        feedPinnedData.map((feed, index) => {
          return feed.has_been_deleted === 0 ? (
            <div
              key={feed.id}
              id={feed.id}
              data-typeid={(feed.relation && feed.relation.id) || (entity && entity.id)}
              data-type={(feed.relation && feed.relation.type) || (entity && entity.type)}
              data-groupid={entity && entity.groupId}
              className={`${feedContainerCSS} ${index !== 0 && styles.isPinnedFeed}`}>
              {renderFeedContent(feed, index, true)}
            </div>
          ) : null
        })}
    </React.Fragment>
  )
}

export default PinnedFeeds
